import React from "react";

export default function PermissionError(props) {
     
    return(
        <div className="limiter">
                <div className="container h-vh pl-0 pr-0">
                    <div className="col-md-7 pl-0 pr-0">
                        <div className="pass-container" style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                            <div className="logo-container text-center mt-2 mb-4">
                                <div className="text-right">
                                    <button type="button" className="btn btn-secondary text-uppercase" onClick={props.logout}>Logout</button>
                                </div>
                                <img src={require('../assets/images/logo_white.svg')} alt="" />
                                <div className='text-center mt-4'>
                                    <span style={{background: '#dc3545', padding: '5px 10px', borderRadius: '5px'}}>You do not have permission to purchase the visitor pass.</span>
                                </div>
                            </div>
                            <div className="copyright mt-5 text-center text-uppercase"><a href="https://blinkay.com/">© Blinkay</a> {(new Date().getFullYear())}. All Rights Reserved</div>
                        </div>
                    </div>
                </div>
            </div>
    )    
}